import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

import CustomIcons from './icons/CustomIcons';

const Link = ({
  children, href, icon, onClick, target, useDefault,
}) => {
  const handleOnClick = (event) => {
    if (!useDefault) {
      event.preventDefault();
    }
    onClick();
  };

  return (
    <a href={href} className="link" onClick={handleOnClick} target={target}>
      <CustomIcons iconName={icon} />
      {children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  href: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  useDefault: PropTypes.bool,
};

Link.defaultProps = {
  children: [],
  href: '/',
  icon: '',
  onClick: () => { },
  target: '_self',
  useDefault: false,
};

export default Link;
